




























































import Vue from 'vue'
import moment from 'moment'
import { LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST } from '@/store/action-types'
import { MasterDataActionsEnum } from '@/types/enums'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'

interface ComponentData {
  loading: boolean
  validationRules: Function[]

  timeModelList: SimpleWeekTimeModel[]
  selectedTimeModel: any | null
  menu1: boolean
  dateStartIso: string | null
  dateStartFormatted: string | null
  dateRules: Function[]
}

export default Vue.extend({
  name: 'CapacityTimeModelDialog',

  components: { },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''
    const todayIso = moment().format('YYYY-MM-DD')

    return {
      loading: false,
      validationRules: [required],

      timeModelList: [],
      selectedTimeModel: null,
      menu1: false,
      dateStartIso: todayIso,
      dateStartFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        }
      ],
    }
  },

  methods: {
    onFieldStartChange (date: string): void {
      this.dateStartFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurStartDate (): void {
      this.dateStartFormatted = this.dateStartIso && moment(this.dateStartIso).isValid() ? moment(this.dateStartIso).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {

      }
    }
  },

  async created () {
    this.loading = true
    try {
      const data = await this.$store.dispatch(LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST, { action: MasterDataActionsEnum.Read })
      this.timeModelList = data
    } catch {

    } finally {
      this.loading = false
    }
  }
})
